import React from 'react'
import { createRoot } from 'react-dom/client' // Import createRoot from react-dom
import { PrimeReactProvider } from 'primereact/api'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import './index.css'
import './i18n'
import App from './App'
import reportWebVitals from './reportWebVitals'

const root = createRoot(document.getElementById('root')) // Create a root instance

root.render(
	<React.StrictMode>
		<PrimeReactProvider>
			<App />
		</PrimeReactProvider>
	</React.StrictMode>
)

reportWebVitals()